import { type ReactNode } from 'react';

/** Renders an Auszug. The phrase is wrapped in `<mark>` and the rest is text. */
export function KnowledgeSearchExcerpt({ excerpt }: { excerpt: string }) {
  const nodes: ReactNode[] = [];
  const pattern = /<mark>([\s\S]*?)<\/mark>/g;
  let last = 0;
  let key = 0;
  for (const match of excerpt.matchAll(pattern)) {
    const index = match.index ?? 0;
    if (index > last) {
      nodes.push(unescapeExcerpt(excerpt.slice(last, index)));
    }
    nodes.push(<mark key={key}>{unescapeExcerpt(match[1] ?? '')}</mark>);
    key += 1;
    last = index + match[0].length;
  }
  if (last < excerpt.length) {
    nodes.push(unescapeExcerpt(excerpt.slice(last)));
  }
  return <span className="text-sm text-muted-foreground">{nodes}</span>;
}

function unescapeExcerpt(value: string): string {
  return value.replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('&amp;', '&');
}
